export default {
    props: {
        endpoint: {type: String, default: "/admin/ajax"},
        modelType: null,
        modelId: null

    },

    data() {
        return {
            model: {
                id: null,
                type: null
            },
            // media: []
        }
    },

    created() {
        // retrieve model data from component properties or global Pixenio variable
        if (this.modelType) {
            this.model.type = this.modelType;
        } else if (typeof Pixenio != 'undefined' && Pixenio.hasOwnProperty('modelType')) {
            this.model.type = Pixenio.modelType;
        }

        if (this.modelId) {
            this.model.id = this.modelId;
        } else if (typeof Pixenio != 'undefined' && Pixenio.hasOwnProperty('modelId')) {
            this.model.id = Pixenio.modelId;
        }
    },

    methods: {
        retrieveMedia(callback) {
            let vm = this;
            let url = `${vm.endpoint}/media/${this.model.type}/${this.model.id}/content`;
            if (typeof Pixenio != 'undefined' && Pixenio.hasOwnProperty('locale')) {
                url += `/${Pixenio.locale}`;
            }
            let formData = new FormData();

            axios.get(url).then(response => {
                vm.media = response.data;
                callback && callback();
            }).catch(error => {
                console.log(error);
            });
        }



    }



}
